import { AuthService } from '@/services'

export default {
  namespaced: true,
  state: () => ({
    invalidSubscription: false,
  }),
  getters: {
    getInvalidSubscription(state) {
      return state.invalidSubscription
    },
  },
  actions: {
    getInvalidSubscription({ commit }) {
      AuthService.customerSubscriptionError().then(({ data }) =>
        commit('UPDATE_INVALID_SUBSCRIPTION_STATUS', data.has_error_payment)
      )
    },
  },
  mutations: {
    UPDATE_INVALID_SUBSCRIPTION_STATUS(state, value) {
      state.invalidSubscription = value
    },
  },
}
